import { render, staticRenderFns } from "./UserChangePassword.vue?vue&type=template&id=d567ca12&scoped=true&"
import script from "./UserChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./UserChangePassword.vue?vue&type=style&index=0&id=d567ca12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d567ca12",
  null
  
)

export default component.exports